const handleUpdate = (state, action) => {
  const { key, total, paginated, visible } = action

  const newState = {
    ...(state[key] ?? {}),
    total,
    paginated,
    visible
  }

  return {
    ...state,
    [key]: newState
  }
}

const handleChangePage = (state, action) => {
  const { key, forward } = action

  const newState = {
    ...state[key],
    index: (state[key].index ?? 0) + (forward ? 1 : -1)
  }

  return {
    ...state,
    [key]: newState
  }
}

const handleReset = (state, action) => {
  const { key } = action

  const newState = {
    ...(state[key] ?? {}),
    index: 0,
    total: 0,
    paginated: false,
    visible: 0
  }

  return {
    ...state,
    [key]: newState
  }
}

const handleMoveTo = (state, action) => {
  const { key, index } = action

  const newState = {
    ...state[key],
    index
  }

  return {
    ...state,
    [key]: newState
  }
}

export const initialState = {}

export const Actions = {
  UPDATE: 'UPDATE',
  CHANGE_PAGE: 'CHANGE_PAGE',
  RESET: 'RESET',
  MOVE_TO: 'MOVE_TO'
}

const Handlers = {
  [Actions.UPDATE]: handleUpdate,
  [Actions.CHANGE_PAGE]: handleChangePage,
  [Actions.RESET]: handleReset,
  [Actions.MOVE_TO]: handleMoveTo
}

export const UIPaginationStateReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown UIPaginationState reducer type: ${type}`)
}
